// src/components/MapIcon.js
import React from "react";
import { motion } from "framer-motion";

const svgVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1, delayChildren: 0.2 },
  },
};

const itemVariants = {
  hidden: { pathLength: 0, opacity: 0 },
  visible: {
    pathLength: 1,
    opacity: 1,
    transition: { duration: 1.5, ease: "easeInOut" },
  },
};

export default function MapIcon({ gradientId }) {
  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      variants={svgVariants}
      initial="hidden"
      animate="visible"
    >
      {/* 지구본 원 */}
      <motion.circle
        cx="50" cy="50" r="40"
        fill={`url(#${gradientId})`}
        fillOpacity="0.1"
        stroke={`url(#${gradientId})`}
        strokeWidth="3"
        variants={itemVariants}
      />
      {/* 위도/경도 선 */}
      <motion.ellipse cx="50" cy="50" rx="20" ry="40" fill="none" stroke={`url(#${gradientId})`} strokeWidth="2" strokeOpacity="0.5" variants={itemVariants} />
      <motion.line x1="10" y1="50" x2="90" y2="50" stroke={`url(#${gradientId})`} strokeWidth="2" strokeOpacity="0.5" variants={itemVariants} />
      <motion.path d="M20 35 C 50 15, 50 15, 80 35" fill="none" stroke={`url(#${gradientId})`} strokeWidth="2" strokeOpacity="0.5" variants={itemVariants} />
      <motion.path d="M20 65 C 50 85, 50 85, 80 65" fill="none" stroke={`url(#${gradientId})`} strokeWidth="2" strokeOpacity="0.5" variants={itemVariants} />
    </motion.svg>
  );
}